var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10045",
    "data-name": "Group 10045",
    transform: "translate(-14 -588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10044",
    "data-name": "Group 10044",
    transform: "translate(-86 -357)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17707",
    "data-name": "Rectangle 17707",
    width: 16,
    height: 16,
    rx: 3,
    transform: "translate(100 945)",
    fill: "#2699fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2348",
    "data-name": "Path 2348",
    d: "M-18884.52,6298.679l3.9,3.537,5.6-8.61",
    transform: "translate(18901.77 -5701.91)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBlue);
export default __webpack_public_path__ + "static/media/checked-blue.f1a914b4.svg";
export { ForwardRef as ReactComponent };